type FirebaseLikeError = {
  code?: unknown;
  message?: unknown;
};

export function isPermissionDeniedError(error: unknown): boolean {
  const candidate = (error ?? {}) as FirebaseLikeError;
  const code = String(candidate.code || "").toLowerCase();
  const message = String(candidate.message || "").toLowerCase();

  return (
    code === "permission-denied" ||
    code.endsWith("/permission-denied") ||
    message.includes("missing or insufficient permissions")
  );
}

export function getPermissionDeniedMessage(fallback?: string): string {
  return fallback || "This action was blocked by Firestore permissions. No changes were saved.";
}
